export const auth0AuthenticatedCookieName = `auth0.${process.env.AUTH0_CLIENT_ID}.is.authenticated`
